import KnowledgeBaseDataStore from '../datastores/KnowledgeBaseDataStore';
import KnowledgeBaseDataStoreApiRest from '../datasources/axios/api/knowledgeBase';

export default class KnowledgeBaseDataStoreFactory {
  static create(): KnowledgeBaseDataStore {
    return new KnowledgeBaseDataStoreApiRest();
  }
}
